export const ZAxisIcons = {
    Up: 'up',
    Down: 'down',
    UpTop: 'downTop',
    DownTop: 'upTop',
  };
  